import { Action } from '@ngrx/store';
import { IRpaConnectionUiPath } from 'app/rpa-bots/core/IRpaBots';

export enum EUIPathConnActions {
  UIPathConnList = '[UIPath Connectors] List of connectors from UIPath',
  UIPathConnListSuccess = '[UIPath Connectors] List of connectors from UIPath Success',
  getCurrentUIPathConn = '[UIPath Connectors] get the selected connector from server',
  getCurrentUIPathConnSuccess = '[UIPath Connectors] get the selected connector from server success',
  UpdateUIPathConn = '[UIPath Connectors] Update selected UIPath connector',
  UpdateUIPathConnSuccess = '[UIPath Connectors] Update selected UIPath connector Success',
  ShowSuccessToast = '[UIPath Connectors] Show Success toast from update action',
  ResetUIPathState = '[UIPath Connectors] Reset automation anywhere state',
  TestUIPathConn = '[UIPath Connectors] Test selected UIPath connector',
  TestUIPathConnSuccess = '[UIPath Connectors] Test selected UIPath connector Success',
}

export class UIPathConnList implements Action {
  public readonly type = EUIPathConnActions.UIPathConnList;
}

export class UIPathConnListSuccess implements Action {
  public readonly type = EUIPathConnActions.UIPathConnListSuccess;
  constructor(public payload: IRpaConnectionUiPath[]) {}
}

export class getCurrentUIPathConn implements Action {
  public readonly type = EUIPathConnActions.getCurrentUIPathConn;
  constructor(public payload: string) {} // The payload is the id of connector
}

export class getCurrentUIPathConnSuccess implements Action {
  public readonly type = EUIPathConnActions.getCurrentUIPathConnSuccess;
  constructor(public payload: IRpaConnectionUiPath) {}
}

export class UpdateUIPathConn implements Action {
  public readonly type = EUIPathConnActions.UpdateUIPathConn;
  constructor(public payload: IRpaConnectionUiPath) {}
}

export class UpdateUIPathConnSuccess implements Action {
  public readonly type = EUIPathConnActions.UpdateUIPathConnSuccess;
}

export class ResetUIPathState implements Action {
  public readonly type = EUIPathConnActions.ResetUIPathState;
}

export class ShowSuccessToast implements Action {
  public readonly type = EUIPathConnActions.ShowSuccessToast;
}

export class TestUIPathConn implements Action {
  public readonly type = EUIPathConnActions.TestUIPathConn;
  constructor(public payload: IRpaConnectionUiPath) {}
}

export class TestUIPathConnSuccess implements Action {
  public readonly type = EUIPathConnActions.TestUIPathConnSuccess;
  constructor() {}
}

export type UIPathConnActions =
  | UIPathConnList
  | UIPathConnListSuccess
  | getCurrentUIPathConn
  | getCurrentUIPathConnSuccess
  | UpdateUIPathConn
  | UpdateUIPathConnSuccess
  | ShowSuccessToast
  | ResetUIPathState
  | TestUIPathConn
  | TestUIPathConnSuccess;
